import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import {
  OrderHistory,
  ResultsDeliveryService,
  ResultsDeliveryStatus,
} from '@compumark/analyst-selection-tool-client';

@Component({
  selector: 'app-rerun-renderer',
  standalone: false,
  templateUrl: './rerun-renderer.component.html',
  styleUrls: ['./rerun-renderer.component.scss'],
})
export class RerunRendererComponent {
  constructor(private service: ResultsDeliveryService) {}

  orderHistory!: OrderHistory;
  isSubmitting = false;

  agInit(params: ICellRendererParams): void {
    this.orderHistory = params.data;
  }

  isReRunInProgress(): boolean {
    return !this.isCompleted() && this.orderHistory.rerun!;
  }

  isCompleted(): boolean {
    return (
      this.orderHistory.status! === ResultsDeliveryStatus.COMPLETED ||
      this.orderHistory.status! === ResultsDeliveryStatus.CANCELLED ||
      this.isFailed()
    );
  }

  isCancelling(): boolean {
    return (
      this.orderHistory.status! === ResultsDeliveryStatus.CANCELLATION_REQUESTED
    );
  }

  isFailed(): boolean {
    return (
      this.orderHistory.status! === ResultsDeliveryStatus.ERROR ||
      this.orderHistory.status! === ResultsDeliveryStatus.TOO_MANY_RESULTS ||
      this.orderHistory.status! === ResultsDeliveryStatus.SEARCH_FAILED ||
      this.orderHistory.status! === ResultsDeliveryStatus.RISK_ASSESSMENT_FAILED
    );
  }

  isNewSearchInProgress(): boolean {
    return !this.isCompleted() && !this.isReRunInProgress();
  }

  cancelResultsDelivery(): void {
    if (
      confirm(
        'Are you sure ? The processing of the search will be stoped !!!',
      ) === true
    ) {
      this.isSubmitting = true;
      this.orderHistory.status = ResultsDeliveryStatus.CANCELLATION_REQUESTED;
      this.service.cancelResultsDelivery(this.orderHistory.id).subscribe();
    }
  }

  reRun(): void {
    if (
      confirm('Are you sure ? All customer data will be erased !!!') === true
    ) {
      this.isSubmitting = true;
      this.orderHistory.status = ResultsDeliveryStatus.NEW;
      this.orderHistory.rerun = true;
      this.service.rerun(this.orderHistory.id).subscribe();
    }
  }
}
